// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const FieldsWrapper = styled.div`
  display: -ms-grid;
  -ms-grid-columns: (12em 1em)[2] (auto 1em)[2] 1fr 1em auto;


  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "username project-name search-button create-button . project-status";
  grid-template-columns: 12em 12em auto auto 1fr auto;
  grid-template-rows: auto;
  padding: 1em;

  > .username {
    grid-area: username;
    -ms-grid-column: 1;
  }

  > .project-name {
    grid-area: project-name;
    -ms-grid-column: 3;
  }

  > .search-button,
  > .create-button {
    font-size: 1rem;
    height: 2em;
    margin-top: 1.3em;
  }

  > .search-button {
    grid-area: search-button;
    -ms-grid-column: 5;
  }

  > .create-button {
    grid-area: create-button;
    -ms-grid-column: 7;
  }

  > .project-status {
    grid-area: project-status;
    -ms-grid-column: 11;
  }
`

export const PaginationRow = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: end;
  justify-content: flex-end;


  // only display the border if this node has children.
  &:not(:empty) {
    border-bottom: 1px solid;
    border-top: 1px solid;
    padding: .5em;
  }

  > h5 {
    padding-top: 0;
  }
`
